import { Injectable } from '@angular/core';
import { isPlatform} from "@ionic/angular";


declare var FirebasePlugin;

@Injectable({
  providedIn: 'root'
})
export class FirebaseService {

  constructor() {}

  init() {
    if (isPlatform("ios") && isPlatform("cordova")) {
      FirebasePlugin.getToken(token => {
        console.log("Firebase Token: ", token);
      });
    }
  }

  logCustomEvent(eventName: string, params: any = {}) {
    if (isPlatform("ios") && isPlatform("cordova")) {
      FirebasePlugin.logEvent(eventName, params,
        () => { console.log("GA4 Event Logged:", eventName); },
        (err) => { console.log("GA4 LogEvent Error:", err); }
      );
    }
  }

  setUserId(userId: string) {
    FirebasePlugin.setUserId(userId);
  }

  setScreen(screenName: string) {
    FirebasePlugin.setScreenName(screenName);
  }
}